import MuiTypography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
import { EmailRounded } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { green, red } from '@mui/material/colors';
import Text from '../../../components/detail/components/Text.component';
import { DepartmentsConf } from '../../../core/dashboard/conf/Data.conf';
import _ from 'lodash';
import RectangleChip from '../../../components/common/RectangleChip.component';

export const ListConf = {
	initialState: {
		pagination: {
			page: 1,
			pageSize: 25,
		},
		sort: {
			by: 'createdAt',
			direction: 'desc',
		},
	},
	rowsPerPageOptions: [25, 50, 100],
	columns: [
		{
			id: 'name',
			key: 'name',
			sort_key: 'name',
			sortable: true,
			label: 'Name',
			width: '120px'
		},
		{
			id: 'surname',
			key: 'surname',
			sort_key: 'surname',
			sortable: true,
			label: 'Surname',
			width: '120px'
		},
		{
			id: 'id_users_nautica.id_users_nautica_departments[0].id_department.name_department',
			key: 'name_department',
			sort_key: 'id_users_nautica.id_users_nautica_departments.id_department.name_department',
			sortable: true,
			label: 'Department',
		},
		{
			id: 'email',
			key: 'email',
			sort_key: 'email',
			sortable: true,
			label: 'Email',
		},
		{
			id: 'phone_number',
			key: 'phone_number',
			sort_key: 'id_users_nautica.phone_number',
			sortable: true,
			label: 'Phone',
		},
		{
			id: 'blocked',
			key: 'blocked',
			sort_key: 'blocked',
			sortable: true,
			label: 'Status',
		},
		{
			id: 'id_users_role.role',
			key: 'id_users_role.role',
			sort_key: 'id_users_role.role',
			sortable: true,
			label: 'Role',
		},
		{
			id: 'id_users_nautica.id_teams',
			key: 'id_teams',
			sort_key: 'id_users_nautica.id_teams.name',
			sortable: false,
			label: 'Team',
		},
	],
	render: {
		formatHead: (key, value) => {
			switch (key) {
				default:
					return (
						<MuiTypography
							variant='body1'
							sx={{ fontWeight: 'bold', color: 'white' }}>
							{value.toUpperCase()}
						</MuiTypography>
					);
			}
		},
		formatValue: (key, value, onClick) => {
			switch (key) {
				case 'email':
					return (
						<Stack direction={'row'} spacing={1} alignItems={'center'}>
							<EmailRounded color='action' />
							<MuiTypography sx={{ fontWeight: 'bold', height: 1 }} variant='body1' onClick={onClick}>
								{value}
							</MuiTypography>
						</Stack>
					);
				case 'blocked':
					return (
						<Text
							label=''
							value={value ? <CancelIcon sx={{ color: red[500] }} /> : <CheckCircleIcon sx={{ color: green[500] }} />}
						/>
					);
				case 'id_teams':
					return (
						<MuiTypography variant='body1' onClick={onClick}>
							{Array.isArray(value) && value.length > 0 ? value.map((t) => t.name).join(', ') : '-'}
						</MuiTypography>
					);
				case 'name_department':
					const departmentColor = _.find(
						DepartmentsConf,
						(item) => item?.title?.toUpperCase() === value?.toUpperCase()
					);
					return (
						<Box onClick={onClick}>
							{value ? <RectangleChip value={value} backgroundColor={departmentColor?.color || '#0049b2'} color='#fff' width={158} /> : '-'}
						</Box>
					);
				default:
					return (
						<MuiTypography variant='body1' onClick={onClick}>
							{value ? value : '-'}
						</MuiTypography>
					);
			}
		},
	},
};
